<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AxWW8F/tc-custom/9781524864996.jpg?1708400295715" alt="This image is the cover for the book Miss Manners' Guide to Contagious Etiquette, Miss Manners"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miss Manners' Guide to Contagious Etiquette, Miss Manners
      </h1>
      <p class="bookDescription body article font2">
        <p>From how to connect when we’re physically distant to the most effective way to advocate for better public health practices in your community (hint: it is not by yelling at jogging neighbors), Miss Manners guides readers through the unprecedented circumstances of the current global pandemic with humanity and wit.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Martin, Nicolas Martin, Jacobina Martin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69c8789a